module.exports = __webpack_public_path__ + "img/welding-6.f7a0c4f9.jpg";